<template>
  <tile class="opc-zpa">
    <foldable v-model="isExpanded" :title="title">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img :src="logo" class="opc-zm-base-card__logo" :alt="title + ' Icon'" tabindex="-1" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h1 class="opc-zm-base-card__name text-capitalize" :class="{
            'opc-zm-base-card__name-collapse': !isExpanded
          }">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h1>
          <div v-if="!isExpanded" slot="collapse" class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset">
            <ul>
              <li v-for="p in data_mx_selectedPlans" :key="p.sub_type">
                {{ $t('billing.pbx.cart_summary.add_on_lines_2', [p.cartInfo.selected_number,
                `${$money(p.amount)}${data_mx_unit}`]) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="divide-line"></div>
      <div class="opc-zpa__main">
        <zm-form>
          <p class="opc-zpa__desc">
            {{ $t('billing.pbx.additional_phone_numbers_config.desc', { amount: $money(amount), unit: data_mx_unit }) }}
          </p>
          <zm-form-item class="horizontal-form-item">
            <InputNumberWithPopover v-model="form.number" :min="minHost" :max="maxHost" :decrease-tips="decreaseTips"
              @change="handleNumberChange" size="large" :disabled="disabled" controls-position="both" label="Add Additional numbers Select the number of users"/>
            <span class="opc-zpa__unit">
              {{ $t('billing.planform.unit.number') }}<priceVATTip />
            </span>
          </zm-form-item>
        </zm-form>
        <div class="opc-zm-base-card__main__footer">
          <div class='opc-zm-base-card__btn--wrap'>
            <zm-tooltip :disabled='!disableDeleteTips' placement='top' tabindex="-1">
              <template #content>
                <div v-html='disableDeleteTips'></div>
              </template>
              <div>
                <zm-button :disabled='disabled || disableDeleteTips' type='link' ghost @click='removePlanByKey'
                            :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}
                </zm-button>
              </div>
            </zm-tooltip>
          </div>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import logo from '@/assets/plans/zoom_phone_additional.svg'
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import { BILLING_CYCLE, contactUsPath, DEFAULT_MAX_HOST, planTypes } from '@/common/constants';
import plansMixin from '@/plans/mx/plan';
import { flowTypes } from '@/common/service/page-config';
import { get } from 'lodash';
import dataMixin from './data';

export default {
  data() {
    return {
      logo,
      title: this.$t('billing.pbx.additional_phone_numbers'),
      isExpanded: true,
      form: {
        number: 0,
      },
    };
  },
  mixins: [plansMixin, dataMixin],
  components: {
    Foldable,
    Tile,
    InputNumberWithPopover,
  },
  created() {
    this.initConfigCart();
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      'getSelectedPlans': 'getSelectedPlans',
      'getUserCurrentSubscriptions': 'getUserCurrentSubscriptions',
      'plancodeMapSubscriptionDisabled': 'plancodeMapSubscriptionDisabled',
      'boughtPlans': 'boughtPlans',
      'basicConfig': 'basicConfig',
    }),
    allPlans() {
      return this.planMapFlat.filter(item => item.type === planTypes.ZOOM_PHONE$ADDITIONAL);
    },
    selectPN() {
      return this.data_mx_selectedPlans.find(item => item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER);
    },
    boughtPN() {
      return this.data_mx_boughtPlans.find(item => item.sub_type === PBX_SUB_TYPES.PHONE_NUMBER);
    },
    cycleMap() {
      return {
        [BILLING_CYCLE.MONTHLY]: this.allPlans.find(item => item.billing_cycle === BILLING_CYCLE.MONTHLY),
        [BILLING_CYCLE.ANNUAL]: this.allPlans.find(item => item.billing_cycle === BILLING_CYCLE.ANNUAL),
      }
    },
    defaultPN() {
      if (this.selectPN) return this.selectPN;
      return this.cycleMap[this.data_mx_currentBillingCycle];
    },
    disabled() {
      const planCode = this.selectPN?.plan_code;
      return !!this.plancodeMapSubscriptionDisabled[planCode];
    },
    isStandardPrice() {
      const isEditFlow = this.$context.flow === flowTypes.edit;
      return (isEditFlow && !this.hasAccountDiscount) ? this.boughtPN?.isStandardPrice : true;
    },
    minHost() {
      if (this.$context.flow === flowTypes.edit && (this.basicConfig.downSellData.disableDownSell || !this.isStandardPrice)) {
        return get(this.boughtPN, 'cartInfo.selected_number', 1);
      }
      return 1;
    },
    maxHost() {
      return this.allPlans[0]?.max || DEFAULT_MAX_HOST;
    },

    decreaseTips() {
      if (this.selectPN?.cartInfo?.selected_number <= this.selectPN?.cartInfo?.selected_number) {
        if (this.basicConfig.downSellData.disableDownSell) {
          return this.$t('billing.error.can_not_bought_plan_tips');
        }

        return this.forNonStandardPriceTips;
      }

      return '';
    },
    amount() {
      if (!this.selectPN) {
        return 0;
      }
      return this.selectPN.amount;
    },
    disableDeleteTips() {
      const hasBought = this.boughtPlans.find((p) => p.plan_code === this.selectPN?.plan_code);
      if ((hasBought && this.basicConfig?.isDirectSales) || hasBought?.isDisablePlanChangeOnline || hasBought?.ratePlans?.length > 1) {
        return this.$t('billing.cancel_disable_contact_us', {
          url: contactUsPath,
        })
      }
      return null;
    },
  },
  methods: {
    ...mapActions([ 'switchSelectPlan']),
    ...mapMutations({
      updateSelectPlan: 'updateSelectPlan',
    }),
    initConfigCart() {
      if (this.selectPN) {
        this.form.number = this.selectPN.cartInfo.selected_number;
        return;
      }
      this.form.number = 1;
      this.handleNumberChange(1);
    },
    handleNumberChange(number, oldValue) {
      if (oldValue && oldValue > number) {
        this.$tracking.buyInteraction(this.title, `Zoom Phone Additional Local Number - decreace - ${number}`);
      } else if (oldValue && oldValue < number) {
        this.$tracking.buyInteraction(this.title, `Zoom Phone Additional Local Number - increase - ${number}`);
      }
      if (!this.defaultPN) return;
      this.updateSelectPlan({
        plan_code: this.defaultPN.plan_code,
        cartInfo: { selected_number: number },
      });
    },
    switchBillingCycle() {
      if (!this.selectPN) {
        this.initConfigCart()
      }
      const nextZPA = this.cycleMap[this.data_mx_currentBillingCycle];
      if (!nextZPA) return;
      if (this.selectPN.plan_code === nextZPA.plan_code) return;
      this.switchSelectPlan([this.selectPN.plan_code, nextZPA.plan_code, this.selectPN.cartInfo])
    },
  },
  watch: {
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.title}  - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    data_mx_currentBillingCycle(v, ov) {
      if (v !== ov) {
        this.switchBillingCycle();
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zpa {
  .opc-zm-base-card {
    @include media(mobile) {
      &__name-collapse {
        display: block;
        padding-right: 70px;

        .main-icon {
          transform: translateY(-2px);
        }
      }
    }



  }

  .main-icon {
    color: $theme-color;
  }

  &__main {
    margin-top: 18px;
    border-top: none;
  }

  &__name {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #00053D;
    display: flex;
    flex-direction: row;
    align-items: center;

    .zm-icon-success {
      font-size: 16px;
      margin-left: 12px;
    }
  }

  &__desc {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 150%;
    color: #00053D;
    margin-bottom: 16px;
  }

  @include media(tablet, desktop) {
    &__unit {
      margin-left: 8px;
    }
  }

  @include media(mobile) {
    .zm-form-item.horizontal-form-item {
      .zm-form-item__content {
        display: flex;
      }
    }

    &__unit {
      margin-left: 8px;

      &--license {
        color: #00053D;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 16.8px */

        &:first-letter {
          text-transform: capitalize;
        }
      }

      &--price-unit {
        color: #666487;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 14.4px */
      }
    }
  }

  .opc-pbx__desc {

    ul,
    li {
      list-style: none;
    }

    li {
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      color: #00031F;
    }
  }
}

.divide-line {
  width: 100%;
  border-top: 1px solid #dfe3e8;
  margin: 24px 0;
}
</style>
